module.exports = __webpack_public_path__ + "img/art3.dd48f6dc.png";